import React from 'react';
import { Link } from 'react-router-dom';
// import logo from 'images/logo-wide-round.png'; // Adjust the path according to your folder structure

const Footer: React.FC = () => {
  return (
    <footer className="bg-logoPurple text-page py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center md:items-start text-center md:text-left">
          
          {/* Left Side: Logo and Address */}
          <div className="mb-8 md:mb-0">
            <h1 className="text-2xl font-bold mb-4">Jack Reid</h1>
            <p className="text-sm">
            Writer, Poet & PhD researcher in English Literature
            </p>
          </div>

          {/* Center: Navigation Links */}
          <div className="mb-8 md:mb-0">
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-gray-300">Home</Link></li>
              <li><Link to="/archive" className="hover:text-gray-300">Portfolio</Link></li>
              <li><Link to="/research" className="hover:text-gray-300">Research</Link></li>
              <li><Link to="/contact" className="hover:text-gray-300">Contact</Link></li>
              {/* <li><Link to="/privacy" className="hover:text-gray-300">Privacy Policy</Link></li> */}
            </ul>
          </div>

          {/* Right Side: Contact and Social Links */}
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;
